module.exports = __webpack_public_path__ + "media/images/pages/fig_dataFamily_02-cc3e840199349cb3c869298426bf2692.png";